import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RouteSubPage } from "shared/route-types";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EditNotificationsIcon from "@mui/icons-material/EditNotifications";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import FavoriteIcon from "@mui/icons-material/Favorite";
import InfoIcon from "@mui/icons-material/Info";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useGetApiConfigQuery } from "api/generatedApi";

interface Props {
  menuSelectedProps: (page: RouteSubPage) => void;
  subPage: RouteSubPage;
}

export const AccountMenu = (props: Props) => {
  const { subPage } = props;
  const { t } = useTranslation();
  const { data: configurationData } = useGetApiConfigQuery();
  const menuSelectedBackground = "rgba(61, 85, 124, 0.1)";
  const menuNotSelectedBackground = "transparent";

  const isAdmin = configurationData?.isCurrentUserAdmin;

  const menuItemClicked = (page: RouteSubPage) => {
    props.menuSelectedProps(page);
  };

  const isSelected = (page: RouteSubPage) => {
    return subPage == page ? menuSelectedBackground : menuNotSelectedBackground;
  };

  var buttons: { buttonType: RouteSubPage; icon: JSX.Element; display: boolean }[] = [
    {
      buttonType: "profile",
      icon: <AccountCircleIcon color="primary" />,
      display: true,
    },
    {
      buttonType: "notifications",
      icon: <EditNotificationsIcon color="primary" />,
      display: true,
    },
    {
      buttonType: "projects",
      icon: <LocationCityIcon color="primary" />,
      display: true,
    },
    {
      buttonType: "favorites",
      icon: <FavoriteIcon color="primary" />,
      display: true,
    },
    {
      buttonType: "admin",
      icon: <AdminPanelSettingsIcon color="primary" />,
      display: isAdmin === true,
    },
    {
      buttonType: "information",
      icon: <InfoIcon color="primary" />,
      display: true,
    },
  ];

  return (
    <Grid sx={{ height: "100%", backgroundColor: "primary.light", overflowY: "auto" }} id="menu_container">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: 1,
          pl: "15px",
          mt: "5%",
          cursor: "pointer",
        }}
        onClick={() => menuItemClicked("folders")}
      >
        <ArrowBackIcon color="primary" fontSize="medium" />
        <Typography variant="h6" color="primary.main" sx={{ paddingLeft: "10px" }}>
          {t("account.menu.back")}
        </Typography>
      </Box>

      <Divider sx={{ margin: "10px 0" }} />

      <Typography variant="h6" color="primary.main" sx={{ paddingLeft: "15px", marginTop: "10px", marginBottom: "10px", fontWeight: "800", cursor: "default" }}>
        {t("account.menu.title")}
      </Typography>

      {buttons
        .filter((button) => button.display)
        .map((button) => (
          <Button
            key={"accountButton_" + button.buttonType}
            onClick={() => menuItemClicked(button.buttonType)}
            sx={{
              width: "100%",
              justifyContent: "left",
              textTransform: "initial",
              background: isSelected(button.buttonType),
            }}
          >
            {button.icon}
            <Typography variant="h6" color="primary.main" sx={{ paddingLeft: "10px" }}>
              {t("account.menu." + button.buttonType)}
            </Typography>
          </Button>
        ))}
    </Grid>
  );
};
